<p-toast [position]="position" [key]="key" [life]="life" [unstyled]="true">
  <ng-template let-message #headless pTemplate="message" let-closeFn="closeFn">
    <div
      class="flex p-3! flex-row items-center justify-between w-full gap-3 shadow rounded-lg border-r-4 border-(--p-badge-{{
        message.severity
      }}-color) bg-(--p-badge-{{ message.severity }}-background)"
    >
      <div class="flex-1 flex flex-row items-center">
        <i
          class="pi pi-{{ severityIcon(message.severity) }} text-(--p-badge-{{
            message.severity
          }}-color)"
        >
        </i>
        <div
          class=" px-1 inline-block text-(--p-badge-{{
            message.severity
          }}-color)"
        >
          {{ message.summary }}
        </div>
        @if (message.detail) {
        <button
          type="button"
          class="cursor-pointer underline mr-1"
          [pTooltip]="message.detail"
          tooltipPosition="bottom"
          [escape]="false"
          [autoHide]="false"
          tooltipStyleClass="toast-detail-tooltip"
        >
          جزئیات بیشتر
        </button>
        }
      </div>
      @if (copyEnabled) {
      <ng-icon
        name="lucideCopy"
        class="cursor-pointer text-black! !hover:text-gray-800"
        (click)="
          copyToClipboard(
            message.summary + (message.detail ? ' ' + message.detail : '')
          )
        "
      >
      </ng-icon>
      }
      <p-button
        icon="pi pi-times"
        [text]="true"
        [severity]="message.severity"
        (click)="closeFn($event)"
      />
    </div>
  </ng-template>
</p-toast>
